export const CHECKLIST_TIPOS = [
  { value: 'basico', label: 'Básico' },
  { value: 'especifico', label: 'Específico' },
  { value: 'tecnico', label: 'Técnico' },
];

export function checklistTipoLabel(value) {
  return CHECKLIST_TIPOS.find((item) => item.value === value)?.label || 'Básico';
}

export function normalizeChecklistTipo(value) {
  const raw = String(value || 'basico')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
  if (raw.startsWith('espec')) return 'especifico';
  if (raw.startsWith('tecnic')) return 'tecnico';
  return 'basico';
}
